import {
  OverallAirbnbRatingsContainer,
  RatingsAndCategoriesContainer,
} from './OverallAirbnbRatings.styles';
import useAirbnbRatingStats from './useAirbnbRatingStats';
import AverageRatingReviews from './AverageRatingReviews';
import CategoryScores from './CategoryScores';
import StarRatingsBreakdown from './StarRatingsBreakdown';

const OverallAirbnbRatings = () => {
  const { airbnbRatingStats, isLoading } = useAirbnbRatingStats();

  if (isLoading || !airbnbRatingStats) {
    return null;
  }

  return (
    <OverallAirbnbRatingsContainer>
      <AverageRatingReviews
        averageRating={airbnbRatingStats.rating}
        reviewsAmount={airbnbRatingStats.count}
        reviewUidsWithIssues={airbnbRatingStats.reviewUidsWithIssues}
      />
      <RatingsAndCategoriesContainer>
        <StarRatingsBreakdown
          ratings={airbnbRatingStats.starRatings}
          totalCount={airbnbRatingStats.count}
        />

        <CategoryScores
          categoryStatistics={airbnbRatingStats.categoryStatistics}
        />
      </RatingsAndCategoriesContainer>
    </OverallAirbnbRatingsContainer>
  );
};

export default OverallAirbnbRatings;
